import React from 'react';
import { 
  Container, 
  Typography, 
  Grid, 
  Box, 
  Card, 
  CardContent, 
  CardMedia,
  useTheme
} from '@mui/material';
import { 
  DataObject, 
  Analytics, 
  SmartToy, 
  PhoneAndroid, 
  Settings
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { getTranslation } from '../../i18n';
import ContactForm from '../contact/ContactForm';

const ContactPage = () => {
  const { language } = useSelector((state) => state.ui);
  const translations = getTranslation(language);
  const t = translations.contact;
  const theme = useTheme();

  // Service cards with icons
  const services = [
    {
      title: t.services.dataCollection,
      icon: <DataObject fontSize="large" color="primary" />,
    },
    {
      title: t.services.dataAnalysis,
      icon: <Analytics fontSize="large" color="primary" />,
    },
    {
      title: t.services.aiDevelopment,
      icon: <SmartToy fontSize="large" color="primary" />,
    },
    {
      title: t.services.appDevelopment,
      icon: <PhoneAndroid fontSize="large" color="primary" />,
    },
    {
      title: t.services.integrations,
      icon: <Settings fontSize="large" color="primary" />,
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      {/* Header */}
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom>
          {t.title}
        </Typography>
        <Typography variant="h5" color="text.secondary" sx={{ mb: 4 }}>
          {t.subtitle}
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: 800, mx: 'auto' }}>
          {t.description}
        </Typography>
      </Box>

      {/* Services Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ mb: 4, textAlign: 'center' }}>
          {t.services.title}
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card 
                elevation={2} 
                sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: theme.shadows[8],
                  }
                }}
              >
                <CardContent sx={{ flexGrow: 1, textAlign: 'center', py: 4 }}>
                  <Box sx={{ mb: 2 }}>
                    {service.icon}
                  </Box>
                  <Typography variant="h6" component="h3">
                    {service.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Contact Form Section */}
      <Box sx={{ mb: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <ContactForm />
          </Grid>
        </Grid>
      </Box>

      {/* Footer Section */}

    </Container>
  );
};

export default ContactPage;
